import styled from 'styled-components';

export const MdiOptions = styled.span`
    width: 18px;
    height: 18px;
    background-image: url(${({ imageSrc }) => imageSrc && imageSrc});
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    margin-right: 5px;
`;

export const OrderDetailFooterBottomNavWrapper = styled.div`
    @media (max-width: 576px) {
        > div {
            bottom: 0;
        }
    }

    @media (min-width: 577px) and (max-width: 850px) and (orientation: portrait) {
        > div {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100% !important;
            z-index: 1;
        }
    }

    button {
        @media only screen and (max-device-width: 360px) {
            font-size: 13px !important;
        }
    }
`;

export const TorqueQROverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(47, 45, 70, 0.53);
    z-index: 1500;
`;
